<ng-container *transloco="let t">
  <app-nav-tabs [reduceHorizontalSpacing]=true #nav>
    <app-nav-tab [title]="t('organiser.race.details.tab.basic.data')" [itemId]="1" [showIndicator]="true"
                 [isChecked]="isRaceValid && !disableEditing()">
      <ng-template>
        @if (isEventCopyComponent() || !isEventValid) {
          <ng-template [ngTemplateOutlet]="warning"/>
        }
        <app-race-details-basic-info [event]="currentEvent" [race]="currentRace" [sports]="sports" [statuses]="statuses"
                                     [registrationTypes]="registrationTypes" [componentType]="componentType"
                                     (raceBasicDataChange)="onRaceChange($event)"
                                     [disableEditing]="isEventCopyComponent() || !isEventValid"/>
      </ng-template>
    </app-nav-tab>
    <app-nav-tab [title]="t('organiser.race.details.tab.additional.data')" [itemId]="2" [showIndicator]="true"
                 [isChecked]="isAdditionalInfoSaved && !disableEditing()">
      <ng-template>
        <ng-template [ngTemplateOutlet]="warning"/>
        <app-race-details-additional-info [event]="currentEvent" [race]="currentRace"
                                          [scoringForTypes]="scoringForTypes" [countries]="countries"
                                          [disableEditing]="disableEditing()"
                                          (raceAdditionalInfoChange)="onRaceChange($event)"/>
      </ng-template>
    </app-nav-tab>
    <app-nav-tab [title]="t('organiser.race.details.tab.settings')" [itemId]="3" [showIndicator]="true"
                 [isChecked]="isRaceSettingsValid && !disableEditing()">
      <ng-template>
        <ng-template [ngTemplateOutlet]="warning"/>
        <app-race-details-settings [raceSettings]="raceSettings" [race]="currentRace" [categoryList]="categories"
                                   [disableEditing]="disableEditing()" [event]="currentEvent"
                                   [applicationProcedureTypes]="applicationProcedureTypes"
                                   [typeOfApplicationTypes]="typeOfApplicationTypes"
                                   [teamTypes]="teamTypes" [selectionOfTeamMembersTypes]="selectionOfTeamMembersTypes"
                                   [measurementTypes]="measurementTypes"
                                   [measurementPrecisionTypes]="measurementPrecisionTypes"
                                   [startByTypeTypes]="startByTypeTypes" [genderSeparationTypes]="genderSeparationTypes"
                                   [teamRankingTeamSeparationTypes]="teamRankingTeamSeparationTypes"
                                   [rotatingOrderTypes]="rotatingOrderTypes"
                                   [timingSystems]="timingSystems" [timingEquipments]="timingEquipments"
                                   [penaltyMinutesTypes]="visibilityTypes"
                                   (raceSettingsChange)="onRaceSettingsChange($event)"/>
      </ng-template>
    </app-nav-tab>
    <app-nav-tab [title]="t('organiser.race.details.tab.pricing')" [itemId]="4" [showIndicator]="true"
                 [isChecked]="raceCommercialItems.length > 0 && !disableEditing()">
      <ng-template>
        <ng-template [ngTemplateOutlet]="warning"/>
        <app-race-details-pricing [event]="currentEvent" [race]="currentRace"
                                  [raceCommercialItems]="raceCommercialItems"
                                  [raceAdditionalItems]="raceAdditionalItems"
                                  (raceCommercialItemsChanged)="onRaceCommercialItemsChanged($event)"
                                  (raceAdditionalItemsChanged)="onRaceAdditionalItemsChanged($event)"
                                  [registrationFeeTypes]="registrationFeeTypes" [disableEditing]="disableEditing()"
                                  [currencies]="currencies"
                                  [visibilityTypes]="visibilityTypes" [registrationDisplayFlags]="displayFlags"
                                  [languages]="languages"/>
      </ng-template>
    </app-nav-tab>
    <app-nav-tab [title]="t('organiser.race.details.tab.registration.form.settings')" [itemId]="5"
                 [showIndicator]="true" [isChecked]="isApplicationFormSettingsValid && !disableEditing()">
      <ng-template>
        <ng-template [ngTemplateOutlet]="warning"/>
        <app-race-details-registration-settings [disableEditing]="disableEditing()" [race]="currentRace"
                                                [raceSettings]="raceSettings" [event]="currentEvent"
                                                [fieldConfigTypes]="fieldConfigTypes"
                                                [visibilityTypes]="visibilityTypes"
                                                [applicationFormSettings]="applicationFormSettings"
                                                [registrationDisplayFlags]="displayFlags" [meals]="meals"
                                                [disciplines]="disciplines" [sizes]="sizes"
                                                [languages]="languages"
                                                (applicationFormSettingsChanged)="onApplicationFormSettingsChange($event)"/>
      </ng-template>
    </app-nav-tab>
    <app-nav-tab [title]="t('organiser.event.details.tab.checkpoints')" [itemId]="6" [showIndicator]="true"
                 [isChecked]="(currentWaypoints?.length ?? 0) > 0 && !disableEditing()">
      <ng-template>
        <ng-template [ngTemplateOutlet]="warning"/>
        <app-race-waypoints [event]="currentEvent" [race]="currentRace" [disableEditing]="disableEditing()"
                            [waypointTypes]="currentWaypoints" [countries]="countries" [languages]="languages"
                            [waypointMarkerTypes]="waypointMarkerTypes" [raceRoute]="raceRoute"
                            (raceRouteChange)="onRaceRouteChange($event)" [waypointList]="waypointList"
                            (waypointListChange)="onWaypointListChange($event)"/>
      </ng-template>
    </app-nav-tab>
  </app-nav-tabs>

  <ng-template #warning>
    @if (isEventCopyComponent() || !isEventValid) {
      <p>
        <ngb-alert [dismissible]="false" class="warning-info mb-4">
          {{ t("race.details.copy.message.1") }} <strong><a (click)="navigateToEventBasicInfo()">
          {{ t("race.details.copy.message.2") }}</a></strong>
        </ngb-alert>
      </p>
    }
    @if (!isEventCopyComponent() && !!isEventValid && !isRaceValid) {
      <p>
        <ngb-alert [dismissible]="false" class="warning-info mb-4">
          {{ t("race.details.copy.message.1") }} <strong><a (click)="navigateToRaceBasicInfo()">
          {{ t("race.details.invalid.link") }}</a></strong>
        </ngb-alert>
      </p>
    }
  </ng-template>
</ng-container>
